// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"785ccc1c","388":"7d6bcef9","413":"b7f7c22b","627":"7cb82002","938":"0c2e12f9","943":"ad9dd93a"}[chunkId] + ".chunk.js";
};